var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4826_74339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.3434 8.02246V22.1351C48.3434 24.0487 48.3434 25.0054 48.7158 25.7363C49.0434 26.3792 49.5661 26.9018 50.209 27.2294C50.9398 27.6018 51.8966 27.6018 53.8101 27.6018H67.9228M55.1768 44.6849H27.8434M32.1768 58.3516H27.8434M34.6768 31.0182H27.8434M48.3434 7.10156H30.5768C24.8362 7.10156 21.966 7.10156 19.7734 8.21875C17.8447 9.20145 16.2766 10.7695 15.2939 12.6982C14.1768 14.8908 14.1768 17.761 14.1768 23.5016V59.0349C14.1768 64.7754 14.1768 67.6457 15.2939 69.8383C16.2766 71.767 17.8447 73.335 19.7734 74.3177C21.966 75.4349 24.8362 75.4349 30.5768 75.4349H52.4434C58.184 75.4349 61.0542 75.4349 63.2468 74.3177C65.1755 73.335 66.7435 71.767 67.7262 69.8383C68.8434 67.6457 68.8434 64.7754 68.8434 59.0349V27.6016L48.3434 7.10156Z",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4826_74339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 82,
    fill: "white",
    transform: "translate(0.510254 0.269531)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.1b0bd1b85f3b7e01c9a4286c0d86ae0f.svg";
export { ForwardRef as ReactComponent };